export const PREMIUM_DURATION_LABEL = "1 Year";

export function parseMembershipDate(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") return value.toDate();
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function isPremiumActive(profile) {
  const plan = String(profile?.membership || "").toLowerCase();
  if (plan !== "premium") return false;

  const expiresAt = parseMembershipDate(profile?.membershipExpiresAt);
  if (!expiresAt) return true;

  return expiresAt.getTime() > Date.now();
}

export function formatMembershipDate(date) {
  if (!date) return "-";
  const value = date instanceof Date ? date : parseMembershipDate(date);
  if (!value) return "-";

  return value.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatAmountPaise(paise, currency = "INR") {
  const amount = Number(paise || 0) / 100;
  if (currency === "INR") {
    return `Rs ${amount.toLocaleString("en-IN")}`;
  }
  return `${amount.toLocaleString("en-IN")} ${currency}`;
}

export function buildReceiptFromProfile(profile) {
  if (!profile?.lastPaymentId && !profile?.membershipExpiresAt) return null;

  return {
    receiptId: profile.lastPaymentId || "-",
    orderId: profile.lastOrderId || "-",
    planName: profile.membershipPlanName || "Karanki Premium (1 year)",
    amount: profile.lastPaymentAmount ?? null,
    currency: profile.lastPaymentCurrency || "INR",
    paidAt: profile.membershipStartedAt || profile.membershipUpdatedAt,
    validFrom: profile.membershipStartedAt,
    validUntil: profile.membershipExpiresAt,
    memberName: profile.fullName || "Member",
  };
}
